<template>
  <span class="message-delete cursor-pointer text-red-600 hover:text-red-800" @click="deleteMessage">
    <slot>✖</slot>
  </span>
</template>

<script>
export default {
  props: ['message', 'dossier'],
  methods: {
    deleteMessage: function () {
      this.$confirm({
        message: 'Notiz wirklich löschen?',
        button: {
          no: 'Abbrechen',
          yes: 'Löschen'
        },
        callback: confirm => {
          if (confirm) {
            this.performDelete()
          }
        }
      })
    },
    
    performDelete: function () {
      const url = `/diesel_dossiers/${this.dossier.id}/messages/${this.message.id}`
      
      this.$http.delete(url).then(response => {
        Vue.$toast.success('Notiz wurde gelöscht.')
        this.$emit('message-deleted', this.message)
      }, response => {
        Vue.$toast.error('Fehler beim Löschen der Notiz.')
      })
    }
  }
}
</script>